export default {
  club_name: 'Rosa Golfen',
  club_name_short: 'rosagolfen',
  stadium_name: '',
  staging_url: 'https://rosagolfen.api.fangroup.io',
  prod_url: 'https://rosagolfen.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/rosagolfen',
  club_logo: '/assets/teams/rosagolfen.png',
  app_name: 'rosagolfen',
  websale_name: 'rosagolfen',
  ntb_team_id: 10073,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'rosagolfen',
  monolithEnabled: false,
  clubWebsiteEnabled: true,
};
